import Vue from 'vue';
import VueI18n from 'vue-i18n';
import extend from 'extend';
import coveMessages from '@ctrack/cove/dist/messages/messages';
import appMessages from './app-messages';
import customMessages from '@custom/i18n/custom-messages';
import Cove from '@ctrack/cove';

Vue.use(VueI18n);

const messages = extend(true, {}, coveMessages, appMessages, customMessages);

export default new VueI18n({
  locale: 'en',
  messages: Cove.nestMessages(messages)
});
